
import { transformObjectKeys } from "@core/utility/common-utils"
import { transformFromCamelCaseToSnakeCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let deleteCardsLoad = (uiBody:DeleteCardsUIRequestBody): Observable<DeleteCardsAPIRequestBody>=>{

  let apiBody = new DeleteCardsAPIRequestBody({
    data:transformObjectKeys(
      uiBody,transformFromCamelCaseToSnakeCase
    )
  })
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let deleteCardsSuccess = (apiBody:DeleteCardsAPIResponseBody):DeleteCardsUIResponseBody=>{
  let uiBody = new DeleteCardsUIResponseBody()
  return uiBody
}

export class DeleteCardsUIRequestBody {
  constructor(props:Partial<DeleteCardsUIRequestBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  ids:Array<string> = []
  accessToken:string
}

export class DeleteCardsUIResponseBody {
  constructor(props:Partial<DeleteCardsUIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
}

export class DeleteCardsAPIRequestBody {
  constructor(props:Partial<DeleteCardsAPIRequestBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  data:DeleteCardsUIRequestBody
}

export class DeleteCardsAPIResponseBody {
  constructor(props:Partial<DeleteCardsAPIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
}
